import { render, staticRenderFns } from "./BaseHomework.vue?vue&type=template&id=943c3b10&scoped=true"
import script from "./BaseHomework.vue?vue&type=script&lang=js"
export * from "./BaseHomework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943c3b10",
  null
  
)

export default component.exports